import { getCategoryHref } from '../../utils/common/category';
import { VIDEO_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'videoTitleGeneratorType',
      analyticsName: 'video_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: VIDEO_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Video',
        value: getCategoryHref(VIDEO_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'videoTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'video_titles_generator',
      placeholder: 'Try "blockchain in food logistics" or "Roblox gaming session"',
      textLabel: "Describe the video's topic",
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: VIDEO_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
